interface Date {
    clone(func: (s: Date) => void): Date;
    equalsYMD(date: Date) : boolean
}
Date.prototype.clone = function(func: (s: Date) => void) {
    let date = new Date(this);
    func(date);
    return date;
};
Date.prototype.equalsYMD = function(date: Date) {
    return date.getDate() == this.getDate() &&
    date.getMonth() == this.getMonth() &&
    date.getFullYear() == this.getFullYear();
};

type SiteLabelDateTimeFormats = 'Date' | 'Time' | 'DateTime';

class SiteLabelDateTime 
    extends SiteLabel<Date, ISiteLabelConfig> {

    private _container: IQueryElement;
    private _input: IQueryElement;
    private _header: IQueryElement;
    private _content: IQueryElement;
    private _format: SiteLabelDateTimeFormats;

    private _activeDate: Date = new Date(Date.now());
    private _months: string[] = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
    private _parser: RegExp = /^([0-9]{1,2}).([0-9]{1,2}).([0-9]{4})((\s)?([0-9]{1,2}).([0-9]{2}))?/g;
    private _formats = {
        Date: "dd-mm-yyyy",
        Time: "HH:MM",
        DateTime: "dd-mm-yyyy HH:MM"
    };

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);

        let input = this.query("input").first();

        if(input === null)
            throw 'SiteLabelDate: Missing element(s)';

        this._input = input;
        if(Site.isMobile() && !Site.hasKeyboard())
            this._input.setAttr("readonly", "true");

        this._format = input.getAttr("data-format") as SiteLabelDateTimeFormats;
        
        let icon = this.getIcon();
        icon && icon.on("click", () => { this.showToggle(); });
        
        this._container = QueryElement.QueryElement('div')
            .addClass("datetime")
            .addClass("popout")
            .addClass("popout-" + this.config.popout);
        
        this._header = QueryElement.QueryElement('div')
            .addClass("header")
            .appendTo(this._container);
        
        this._content = QueryElement.QueryElement('div')
            .addClass("content")
            .appendTo(this._container);
        
        let minYear = new SiteButton({ icon: 'first_page' }, false);
        minYear.on("click", () => this.setMonth(-12));
        let minMonth = new SiteButton({ icon: 'chevron_left' }, false);
        minMonth.on("click", () => this.setMonth(-1));
        let today = new SiteButton({ title: this.getSiteConfig().strings["today"] }, false).addClass("today");
        today.on("click", (e) => { 
            this.setDate(new Date(Date.now())); 
            e.stop();
        });
        let plusMonth = new SiteButton({ icon: 'chevron_right' }, false);
        plusMonth.on("click", () => this.setMonth(1));
        let plusYear = new SiteButton({ icon: 'last_page' }, false);
        plusYear.on("click", () => this.setMonth(12));
        
        let navigation = QueryElement.QueryElement("div").addClass("date-navigation")
            .append(minYear).append(minMonth).append(today).append(plusMonth).append(plusYear)
            .appendTo(this._content);
    

        this.append(this._container);
    }
    getInput() {
        return this._input;
    }
    
    defaultConfig(): ISiteLabelConfig {
        return {
            popout: "normal",
            scroll: "top"
        }
    }
    show() {
        this._container.addClass("show");
    }
    unShow() {
        this._container.removeClass("show");
    }
    showToggle() {
        if (this._container.containsClass("show"))
            this.unShow();
        else
            this.show();
    }

    defaultKeyDownHandler(e: KeyboardEvent) {
        switch (e.keyCode) {
            case 38: // KEY UP 
                this.moveUp();
                break;
            case 40: // KEY DOWN 
                this.moveDown();    
                break;    
        }
        
        //if (e.keyCode != 9)
        //    this.show();
        
        super.defaultKeyDownHandler(e);
    }

    moveUp() {
        let date = this.getValue();
        if (date != null) {
            date.setDate(date.getDate() + 1);
            this.setValue(date);
        }
    }
    moveDown() {
        let date = this.getValue();
        if (date != null) {
            date.setDate(date.getDate() - 1);
            this.setValue(date);
        }
    }

    setMonth(month: number) {
        this._activeDate.setMonth(this._activeDate.getMonth() + month);
        this.renderHeader();

        let leftRight = month < 0 ? "left" : "right";
        
        this._content.query(".dates:not(.out-left):not(.out-right)").first(async a => {
            a.removeClass('in-left').removeClass('in-right').addClass(`out-${leftRight}`);
            await delay(200);
            a.remove();
        });
        this.renderMonth().addClass(`in-${leftRight}`).appendTo(this._content);
    }
    setDate(date: Date) {
        this.setValue(date);
        this._input.select();
        this.makeNextActive();
    }

    makeActive() {
        if (super.makeActive()) {
            if (!this.getSiteConfig().settings.includes("NoAutoPopout"))
                this.show();
            
            this._input.select();
            return true;
        }
        return false;
    }
    makeInactive() {
        super.makeInactive();
        this.unShow();
    }

    renderHeader() {
        this._header
            .setHtml(this._months[this._activeDate.getMonth()] + " " + this._activeDate.getFullYear());
    }
    renderMonth() {
        let dates = QueryElement.QueryElement('div')
            .addClass("dates");

        let days = ['m', 'd', 'w', 'd', 'v', 'z', 'z'];
        for (let x = 0; x < days.length; x++)
        {
            dates.append(QueryElement.QueryElement('button').addClass("header").setHtml(days[x]));
        }

        let selectedDate = this.getValue();
        let firstDayOfMonth = this._activeDate.clone(a => a.setDate(1));
        let extraDays = firstDayOfMonth.clone(a => a.setDate(a.getDate() - 1)).getDay();

        for (let x = extraDays * -1; x < 42 - extraDays; x++)
        {
            let currDate = firstDayOfMonth.clone(a => a.setDate(a.getDate() + x));

            let button = new SiteButton({
                title: currDate.getDate().toString()
            }, false);

            button.on("click", (e) => { 
                this.setDate(currDate); 
                e.stop();
            });

            if(currDate.getMonth() != this._activeDate.getMonth())
                button.addClass('a');
            
            if(selectedDate !== null && selectedDate.equalsYMD(currDate))
                button.addClass('selected');
            
            dates.append(button);
        }
        
        return dates;
    }

    getValue() {
        let value = this._input.getVal();
        if(value === undefined)
            return null;

        let parser = new RegExp(this._parser);

        let parsed = parser.exec(value);
        if(parsed === null || parsed.length === 0)
            return null;
        
        switch (this._format) {
            case 'Date':
                return new Date(Date.UTC(
                    Number(parsed[3]),
                    Number(parsed[2]) - 1,
                    Number(parsed[1])
                ));
            case 'Time':
            case 'DateTime':
                return new Date(
                    Number(parsed[3]), 
                    Number(parsed[2]) - 1, 
                    Number(parsed[1]),
                    Number(parsed[6]),
                    Number(parsed[7])
                );
        }
    }
    setValue(value: Date | null) {
        if(value && !(value instanceof Date))
            value = new Date(value as string);
        
        super.setValue(value);

        this._activeDate = value || new Date(Date.now());

        if (value === null)
            this._input.setVal("");
        else {
            let date = new QueryDate(value);
            switch(this._format) {
                case 'Date':
                    this._input.setVal(
                        date.format(this._formats[this._format], true)
                    );
                    break;
                case 'Time':
                case 'DateTime':
                    this._input.setVal(
                        date.format(this._formats[this._format], false)
                    );
                    break;
            }
        }   
        
        // -- And rerender since value is set:
        this.renderHeader();
        this._content.query(".dates").all(a => a.remove());
        this.renderMonth().appendTo(this._content);
        
        // When date is selected we are done:
        this.unShow();
    }
} 